export default "__VITE_ASSET__CwhuRUcC__";